module.exports = __webpack_public_path__ + "static/baphomet-a26bc01d254129335d883864a8ab0919.png";